import { render, staticRenderFns } from "./CustomRecharge.vue?vue&type=template&id=89453654&scoped=true"
import script from "./CustomRecharge.vue?vue&type=script&lang=js"
export * from "./CustomRecharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89453654",
  null
  
)

export default component.exports